import {
  Grid,
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from '@mui/material';

export function Checkboxes({ title, property, options, state, setState }) {
  const handleChange = (event) => {
    const { name, checked } = event.target;
    
    // Calculate the new state object directly instead of using a function
    const newPropertyValue = checked
      ? [...state[property], name]
      : state[property].filter((item) => item !== name);
    
    const newState = {
      ...state,
      [property]: newPropertyValue
    };
    
    setState(newState);
  };

  return (
    <FormControl component="fieldset" variant="standard" sx={{ mt: 2 }}>
      <FormLabel>{title}</FormLabel>
      <FormGroup>
        <Grid container spacing={1}>
          {options.map((option, idx) => (
            <Grid size={{ xs: 12, sm: 6, md: 3 }} key={idx}>
              <FormControlLabel
                control={
                  <Checkbox
                    name={option.name}
                    checked={state[property].includes(option.name)}
                    onChange={handleChange}
                  />
                }
                label={option.name}
              />
            </Grid>
          ))}
        </Grid>
      </FormGroup>
    </FormControl>
  );
};